import type { ChatAppResponse } from "@/api/models"

type ChatAnswer = [string, ChatAppResponse]

type GetAnswersForReferenceItemsArgs = {
  answersForSpreadsheet: ChatAnswer[]
  isContextPanelOpen: boolean
  isStreaming: boolean
  messages: ChatAnswer[]
}

export function getAnswersForReferenceItems({
  answersForSpreadsheet,
  isContextPanelOpen,
  isStreaming,
  messages,
}: GetAnswersForReferenceItemsArgs): ChatAnswer[] {
  if (isStreaming && !isContextPanelOpen) {
    return messages
  }
  return answersForSpreadsheet
}
